export default __webpack_public_path__ + "static/media/iPhone-XR-Red.b22a467e.svg";